<template>
  <div>
    <v-dialog fullscreen hide-overlay persistent v-model="modal">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{tournamentId ? getName(tournament ? tournament.name : '') : $t('newModel', {field : $tc('tournament')})}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              v-if="tournamentId && can('delete', 'tournament', tournament)"
              @click="dialogDelete = true"
              flat
              color="error"
              class="mr-5"
            >{{$t('delete')}}</v-btn>
            <v-btn
              v-if="tournamentId && can('create', 'tournament')"
              @click="dialogClone = true"
              flat
              class="mr-5"
            >{{$t('duplicate')}}</v-btn>
            <v-btn
              v-if="tournamentId"
              icon
              dark
              :loading="$store.state.tournaments.loading"
              @click="$store.dispatch('tournaments/refresh', tournamentId)"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn @click="$emit('update:modal', false)" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-stepper v-model="stepTour">
          <v-stepper-header>
            <v-stepper-step
              class="cursor"
              :complete="stepTour > 1"
              :step="1"
              @click="setStep(1)"
            >{{$t('generalInformation')}}</v-stepper-step>
            <v-stepper-step
              class="cursor"
              :complete="stepTour > 2"
              :step="2"
              @click="setStep(2)"
            >{{teamsTab}}</v-stepper-step>
            <v-stepper-step
              class="cursor"
              :complete="stepTour > 3"
              :step="3"
              @click="setStep(3)"
            >{{$tc('phase', 2)}}</v-stepper-step>
            <v-stepper-step
              class="cursor"
              :complete="stepTour > 4"
              :step="4"
              @click="setStep(4)"
            >{{$tc('group', 2)}}</v-stepper-step>
            <v-stepper-step
              class="cursor"
              :complete="stepTour > 5"
              :step="5"
              @click="setStep(5)"
            >{{$tc('match', 2)}}</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content :step="1">
              <tab-informacion
                ref="informacion"
                :tournamentExternal="tournament"
                :valid="valid"
                @reset="reset()"
              ></tab-informacion>
            </v-stepper-content>
            <v-stepper-content :step="2">
              <tab-participants :editar="Edit"></tab-participants>
            </v-stepper-content>
            <v-stepper-content :step="3">
              <tab-phases
                :Edit="Edit"
                :phases="tournamentSelected.phases"
                :type="tournamentSelected.type ? tournamentSelected.type : ''"
              ></tab-phases>
            </v-stepper-content>
            <v-stepper-content :step="4">
              <tab-groups
                :Edit="Edit"
                :stadiums="tournamentSelected.stadiumId"
                :phases="tournamentSelected.phases"
                :type="tournamentSelected.type"
              ></tab-groups>
            </v-stepper-content>
            <v-stepper-content :step="5">
              <tab-matches :Edit="Edit" :tournament="tournamentSelected"></tab-matches>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="previousStep()"
            v-if="stepTour > 1"
            color="success"
          >&lt;&lt; {{titulos[stepTour-2]}}</v-btn>
          <template v-if="stepTour == 1">
            <v-btn
              v-if="!tournamentId && can('create', 'tournament')"
              @click="send()"
              small
              color="success"
              :loading="loading"
            >{{$t('create')}}</v-btn>

            <v-btn
              v-if="can('edit', 'tournament', tournamentSelected)"
              @click="send()"
              small
              color="secondary"
              :loading="loading"
            >{{$t('update')}}</v-btn>
          </template>
          <!-- </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
          </template>-->

          <v-btn @click="$emit('update:modal', false)" small color="primary">{{$t('cancel')}}</v-btn>
          <v-btn
            @click="nextStep()"
            v-if="tournamentId && stepTour < 4"
            small
            color="success"
          >{{titulos[stepTour]}} &gt;&gt;</v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="dialogClone" max-width="400">
        <v-card>
          <v-card-title class="headline">{{$t('confirmation')}}</v-card-title>
          <v-card-text v-html="$t('confirmClone', {field: $tc('tournament')})"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialogClone = false" small>{{$t('cancel')}}</v-btn>

            <v-btn color="success" @click="clone()" small>
              <span v-if="loading">
                <v-progress-circular :size="20" :width="3" color="#FFFFFF" indeterminate></v-progress-circular>
              </span>
              <span v-else>{{$t('duplicate')}}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400" style="z-index:1001;">
      <v-card>
        <v-card-title class="headline">{{$t('confirmation')}}</v-card-title>
        <v-card-text v-html="$t('confirmDelete', {field: $tc('tournament'), name: ''})"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" flat="flat" @click="dialogDelete = false">{{$t('cancel')}}</v-btn>

          <v-btn color="error" flat="flat" @click="deleteTour()">
            <span v-if="loadingDelete">
              <v-progress-circular :size="20" :width="3" color="red" indeterminate></v-progress-circular>
            </span>
            <span v-else>{{$t('delete')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import tabInformacion from './TabInformation'
import tabParticipants from './tabParticipants'
import tabPhases from './tabPhases'
import tabGroups from './tabGroups'
import tabMatches from './tabMatches'
import queueToast from '../../../helpers/queueToast'
import { formatDatePicker } from '../../../helpers/dateHelper'
export default {
  name: 'formManager',
  components: {
    tabInformacion,
    tabParticipants,
    tabPhases,
    tabGroups,
    tabMatches
  },
  props: {
    modal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      titulos: [
        this.$t('information'),
        this.$tc('team'),
        this.$tc('phase', 2),
        this.$tc('group', 2),
        this.$tc('match', 2)
      ],
      loading: false,
      stepTour: 1,
      Edit: true,
      dialogClone: false,
      dialogDelete: false,
      loadingDelete: false,
      tournament: {
        name: [],
        description: [],
        numberParticipants: 1,
        act: '',
        active: false,
        startAt: '',
        endAt: '',
        img: '',
        stadiumId: [],
        showRanking: false,
        openInscription: false,
        image: '',
        type: ''
      },
      valid: true
    }
  },
  watch: {
    tournamentSelected: function(val) {
      this.reset()
      const vm = this
      if (val._id) {
        setTimeout(() => {
          vm.assignExternal(val)
        }, 200)
      }
    }
  },
  mounted() {},

  computed: {
    ...mapState({
      languages: state => state.languages.listLanguages,
      defaultLangId: state => state.languages.defaultLangId,
      allStadiums: state => state.stadiums.listStadiums,
      tournamentSelected: state => state.tournaments.selected,
      tournamentId: state => state.tournaments.idSelected
    }),
    teamsTab() {
      if (this.tournament.type === 'users') {
        return this.$tc('user', 2)
      }
      if (this.tournament.type === 'teams') {
        return this.$tc('team', 2)
      }
      return this.$t('participants', 2)
    }
  },
  methods: {
    ...mapActions({
      setNew: 'tournaments/setNew',
      setUpdate: 'tournaments/setUpdate',
      setClearOne: 'tournaments/setClearOne',
      setDelete: 'tournaments/setEliminate'
    }),
    setStep(step) {
      if (this.tournamentId) {
        this.stepTour = step
      }
    },
    nextStep() {
      if (this.stepTour === 1) {
        this.send()
        let validate = this.validateTournament(true)
        if (!validate.error) {
          queueToast(validate.messages)
          this.$refs.informacion.$refs.tipo.hasFocused = true
          return
        }
      }
      if (this.stepTour < 4) {
        this.stepTour++
      }
    },
    previousStep() {
      if (this.stepTour > 1) {
        this.stepTour--
      }
    },

    createTournamet() {
      let name = this.getComplexLanguage(this.tournament.name)
      let description = this.getComplexLanguage(this.tournament.description)

      let result = {
        name: name,
        description: description,
        type: this.tournament.type,
        numberParticipants: this.tournament.numberParticipants,
        act: this.tournament.act,
        active: this.tournament.active,
        startAt: this.tournament.startAt,
        endAt: this.tournament.endAt,
        img: this.tournament.img,
        stadiumId: this.tournament.stadiumId,
        showRanking: this.tournament.showRanking,
        openInscription: this.tournament.openInscription
      }
      if (this.tournament._id) result._id = this.tournament._id
      if (result.type === 'users') result.teams = []
      else result.users = []

      return result
    },
    validateTournament(limit = false) {
      const {
        name,
        type,
        openInscription,
        numberParticipants,
        act,
        startAt,
        endAt,
        stadiumId
      } = this.tournament

      let error = true
      let messages = []
      const spanishLang = name.find(lang => lang.langId === this.defaultLangId)
      if (!spanishLang || !spanishLang.text) {
        error = false
        messages.push(this.$t('error.nameSpanish'))
      }
      if (stadiumId.length === 0) {
        error = false
        messages.push(
          this.$t('error.oneRequired', { field: this.$tc('stadium') })
        )
      }
      if (stadiumId.length > 0) {
        let aulasSum = 0
        stadiumId.forEach(item => {
          let temporalStadium = this.allStadiums.find(
            element => element._id === item
          )
          if (temporalStadium) {
            aulasSum += temporalStadium.pitches.length
          }
        })
        if (aulasSum === 0) {
          error = false
          messages.push(this.$t('error.emptyStadiums'))
        }
      }

      if (!act) {
        error = false
        messages.push(this.$t('error.required', { field: this.$tc('act') }))
      }

      if (!numberParticipants) {
        error = false
        messages.push(
          this.$t('error.required', {
            field: this.$t('numberParticipants', {
              field: this.$t('participants')
            })
          })
        )
      }
      if (!(numberParticipants > 0 && numberParticipants < 101)) {
        error = false
        messages.push(this.$t('error.invalidParticipantsRange'))
      }
      if (type !== 'users' && type !== 'teams' && type !== 'usersTeams') {
        error = false
        messages.push(this.$t('error.required', { field: this.$t('type') }))
      }
      if (!startAt) {
        error = false
        messages.push(this.$t('error.required', { field: this.$t('startAt') }))
      }
      if (!endAt) {
        error = false
        messages.push(this.$t('error.required', { field: this.$t('endAt') }))
      }

      if (!error) this.valid = false
      return {
        error,
        messages
      }
    },
    send(step) {
      let validate = this.validateTournament()
      if (!validate.error) {
        queueToast(validate.messages)
        return
      }
      let tournament = this.createTournamet()
      this.loading = true
      if (!tournament._id)
        this.setNew(tournament).finally(() => (this.loading = false))
      else this.setUpdate(tournament).finally(() => (this.loading = false))
    },
    reset() {
      this.valid = true
      if (this.tournament._id != this.tournamentSelected._id) {
        this.stepTour = 1
      }

      this.tournament = {
        name: this.setComplexLanguage(),
        description: this.setComplexLanguage(),
        numberParticipants: 1,
        act: '',
        active: true,
        startAt: '',
        endAt: '',
        img: '',
        stadiumId: [],
        showRanking: false,
        openInscription: false,
        image: `${process.env.VUE_APP_IMAGE_URL}default-tournament.png`,
        type: ''
      }
    },
    assignExternal(tournament) {
      const img = process.env.VUE_APP_IMAGE_URL + tournament.img
      this.tournament._id = tournament._id
      this.tournament.numberParticipants = tournament.numberParticipants
      this.tournament.act = tournament.act
      this.tournament.active = tournament.active
      this.tournament.startAt = formatDatePicker(tournament.startAt)
      this.tournament.endAt = formatDatePicker(tournament.endAt)
      this.tournament.image = img
      this.tournament.stadiumId = tournament.stadiumId
      this.tournament.showRanking = tournament.showRanking
      this.tournament.openInscription = tournament.openInscription
      this.tournament.type = tournament.type
      this.tournament.name = this.setComplexLanguage(tournament.name)
      this.tournament.description = this.setComplexLanguage(
        tournament.description
      )
    },
    clone() {
      let validate = this.validateTournament()
      if (!validate.error) {
        queueToast(validate.messages)
        return
      }
      let tournament = this.createTournamet()
      delete tournament._id
      delete tournament.teams
      delete tournament.users
      this.deleteTimeStamps(tournament)
      tournament.phases = this.tournamentSelected.phases.slice()

      tournament.name = tournament.name.filter(item => item.text)
      tournament.name.forEach(item => delete item._id)
      tournament.description.forEach(item => delete item._id)
      tournament.phases.forEach(phase => {
        phase.name = phase.name.filter(item => item.text)
        delete phase._id

        this.deleteTimeStamps(phase)
        phase.name.forEach(item => delete item._id)
        phase.groups.forEach(group => {
          group.name = group.name.filter(item => item.text)
          group.name.forEach(item => delete item._id)
          delete group._id
          delete group.matches
          this.deleteTimeStamps(group)
        })
      })
      let spanishLang = tournament.name.find(
        lang => lang.langId === this.defaultLangId
      )
      spanishLang.text += ' (copy)'
      this.loading = true
      this.setNew(tournament)
        .then(() => (this.dialogClone = false))
        .finally(() => (this.loading = false))
    },
    deleteTour() {
      this.loadingDelete = true
      this.setDelete(this.tournamentSelected._id)
        .then(_ => {
          this.dialogDelete = false
          this.$emit('cancel')
        })
        .finally(_ => {
          this.loadingDelete = false
        })
    },
    deleteTimeStamps(item) {
      delete item.createdAt
      delete item.createdBy
      delete item.updatedBy
      delete item.updatedAt
    }
  }
}
</script>
<style scoped>
.cursor:hover {
  cursor: pointer;
}
</style>
